const ko = {
  translation: {
    modify: '변경',
    edit: '수정',
    delete: '삭제',
    view: '보기',
    add: '추가',
    logout: '로그아웃',
    menus: '메뉴',
    search: '검색',
    close: '닫기',
    setting: '설정',
    error: '오류',
    select: '선택',
    cancel: '취소',
    create: '생성',
    upload: '업로드',
    update: '수정',
    sort: '정렬',
    filter: '필터',
    download: '다운로드',
    complete: '완료',
    query: '검색어',
    yesterday: '어제',
    tomorrow: '내일',
    applications: '앱 목록',
    profile: '내 정보',
    letters: '{{cnt}} 글자',
    invite: '초대',
    reset: '초기화',
    male: '남성',
    female: '여성',
    tag: '태그',
    enabled: '활성화',
    disabled: '비활성화',
    name: '이름',
    'n-selected': '{{0}}개 선택됨',
    'no-selection': '선택 없음',
    'period.year': '{{years}}년',
    'period.month': '{{months}}개월',
    'period.day': '{{days}}일',

    'msg.delete-confirm': '정말로 삭제하시겠습니까?',
    'msg.delete-success': '삭제되었습니다',
    'msg.type-query': '검색어를 입력하세요...',

    'common.403.oh': '엥?!',
    'common.403.not-exist': '해당 페이지에 접근할 수 없습니다',
    'common.403.go-to-home': '홈으로',
    'common.404.oh': '앗!',
    'common.404.not-exist': '해당 페이지가 존재하지 않습니다',
    'common.404.go-to-home': '홈으로',
    'common.500.oh': '이런!',
    'common.500.error': '예상하지 못한 에러가 발생했습니다',
    'common.500.go-to-home': '홈으로',
    'CommonNavigation.search': '검색',
    'CommonNavigation.menu': '메뉴',
    'CommonSearchResult.empty-result': '검색 결과가 없습니다',
    'CommonSearchResult.result-num': '{{total}}개',
    'CommonSearchResult.search-status': '{{query}}에 대한 {{total}}개의 검색 결과',
    'common.form.feedback.required': '값을 입력해주세요',
    'common.form.feedback.no-minus': '음수를 입력하실 수 없습니다',
    'common.select.please-select': '값을 선택해주세요',

    'upload.status': '{{now}} / {{total}}개 완료',
    'upload.ready': '준비',
    'upload.upload': '업로드',
    'upload.abort': '중단',
    'upload.aborted': '중단됨',
    'upload.completed': '완료',
    'upload.clear': '초기화',

    'auth.login': '로그인',
    'auth.logout': '로그아웃',
    'auth.login-persist': '로그인 유지',
    'auth.register': '회원가입',
    'auth.sign-out': '회원탈퇴',
    'auth.sign-out.confirm': '정말로 회원탈퇴 하시겠습니까?',
    'auth.sign-out.success': '회원탈퇴에 성공했습니다',
    'auth.id': '아이디',
    'auth.pw': '비밀번호',
    'auth.pw-confirm': '비밀번호 재입력',
    'auth.errMsg.empty-id': '아이디를 입력해주세요',
    'auth.errMsg.empty-pw': '비밀번호를 입력해주세요',
    'auth.errMsg.short-id': '아이디는 4글자 이상이어야 합니다',
    'auth.errMsg.long-id': '아이디는 20글자 이하이어야 합니다',
    'auth.errMsg.wrong-pattern-id': '아이디는 알파벳 또는 숫자로만 이루어져 있어야 합니다',
    'auth.errMsg.short-pw': '비밀번호는 8글자 이상이어야 합니다',
    'auth.errMsg.long-pw': '비밀번호는 100글자 이하이어야 합니다',
    'auth.errMsg.not-equal-pw': '비밀번호가 서로 다릅니다',
    'auth.errMsg.invalid-id-pw': '아이디 또는 비밀번호가 올바르지 않습니다',
    'auth.errMsg.already-exist-id': '이미 존재하는 아이디입니다',
    'auth.errMsg.captcha-required': '캡차의 체크박스를 클릭해주세요.',
    'auth.msg.register-success': '회원가입에 성공했습니다. 방금 가입한 정보로 로그인해주세요',
    'auth.api.valid-url.failure': '잘못된 접근입니다',
    'auth.my-page.title': '내 계정 관리',
    'auth.my-page.login-info': '로그인 정보',
    'auth.my-page.login-status': '로그인 현황',
    'auth.my-page.login-history': '로그인 기록',
    'auth.my-page.login-history-num': '{{0}}건',
    'auth.my-page.login-device': '로그인된 기기 목록',
    'auth.my-page.login-device-num': '{{0}}개의 기기',
    'auth.modify-username-modal.title': '아이디 변경하기',
    'auth.modify-password-modal.title': '비밀번호 변경하기',
    'auth.ProfilePasswordForm.old-pw': '기존 비밀번호',
    'auth.ProfilePasswordForm.new-pw-1': '신규 비밀번호',
    'auth.ProfilePasswordForm.new-pw-2': '신규 비밀번호 재입력',
    'auth.auth-status.exist-id': '이미 존재하는 아이디입니다',
    'auth.auth-status.invalid-length-id': '아이디는 4글자 이상 255글자 이하이어야 합니다',
    'auth.auth-status.invalid-pattern-id': '아이디는 알파벳 또는 숫자로만 이루어져 있어야 합니다',
    'auth.auth-status.invalid-length-password': '비밀번호는 8글자 이상 255글자 이하이어야 합니다',
    'auth.auth-status.wrong-password': '비밀번호가 올바르지 않습니다',
    'auth.auth-status.current-password': '현재 비밀번호와 동일합니다',
    'auth.auth-status.not-exist-user-or-password': '아이디 또는 비밀번호가 올바르지 않습니다',

    'photo.page.album-detail.title': '사진 목록 - {{0}}',
    'AlbumViewerPage.title': '앨범 뷰어',
    'PhotoListPage.title': '내 사진 목록',
    'PhotoSearchModal.title': '사진 검색',

    'apparel.page.list.title': '내 의류 목록',
    'apparel.page.list.inner-title': '총 {{total}}개의 의류',
    'apparel.page.detail.title': '자세한 의류 정보',
    'apparel.page.edit.title': '수정 - {{0}}',
    'ApparelCreatePage.title': '의류 추가하기',
    'apparel.page.category-list.title': '의류 카테고리 목록',
    'apparel.page.category-detail.title': '의류 카테고리 - {{0}} ({{1}}개)',
    'apparel.page.brand-list.title': '의류 브랜드 목록',
    'apparel.page.brand-detail.title': '의류 브랜드 - {{0}} ({{1}}개)',
    'ApparelNavigation.all-apparels': '모든 의류',
    'ApparelNavigation.categories': '종류',
    'ApparelNavigation.brands': '브랜드',
    'apparel.term.name': '이름',
    'apparel.term.itemNo': '상품번호',
    'apparel.term.brand': '브랜드',
    'apparel.term.category': '분류',
    'apparel.term.size': '사이즈',
    'apparel.term.color': '색상',
    'apparel.term.originPrice': '원가',
    'apparel.term.discountPrice': '할인가',
    'apparel.term.buyDt': '구매일',
    'apparel.term.buyLoc': '구매장소',
    'apparel.term.material': '소재',
    'apparel.term.size2': '사이즈 상세',
    'apparel.term.makeDt': '제조년월',
    'apparel.term.discarded': '버렸음',

    'DriveExplorerPage.title': '파일 탐색기',
    'drive.msg.remove-confirm': '정말로 삭제하시겠습니까?',
    DriveNavigation: '파일 탐색기',
    'drive.preview.files-selected': '{{0}}개 선택',
    'drive.rename.replace': '문자열 바꾸기',
    'drive.rename.replace.button': '바꾸기',
    'drive.rename.add-number': '번호 붙이기',
    'drive.rename.pad-number': '자리수 맞추기',
    'drive.rename.number.start-number': '시작 숫자',
    'drive.rename.number.digit': '자리수',
    'drive.rename.add-number.front': '앞에 붙이기',
    'drive.rename.add-number.back': '뒤에 붙이기',
    'drive.rename.pad-number.button': '맞추기',
    'drive.rename.reset': '초기화',
    'drive.rename.apply': '실제로 적용하기',
    'drive.DriveUploadButton.upload': '업로드',
    'drive.DriveUploadButton.upload-files': '파일 업로드',
    'drive.DriveUploadButton.upload-folder': '폴더 업로드',
    'drive.DriveNewFolderModal.title': '새 폴더 생성',
    'drive.DriveNewFolderModal.label': '새 폴더 이름',
    'drive.DriveNewFolderModal.button': '생성',
    'drive.DriveRenameModal.title': '파일 이름 일괄 수정',
    'drive.DriveRenameModal.label': '파일 이름',
    'drive.DriveRenameModal.button': '수정',
    'drive.DriveExplorerBreadcrumb.home': '홈',
    'drive.DriveExplorerFileList.type': '타입',
    'drive.DriveExplorerFileList.name': '이름',
    'drive.DriveExplorerFileList.size': '크기',
    'drive.DriveExplorerFileList.date': '수정한 날짜',
    'drive.DriveExplorerFileList.new-folder': '새 폴더',
    'drive.DriveExplorerFileList.empty-folder': '폴더가 비었습니다.',
    'drive.DriveExplorerFileList.n-files': '{{0}}개의 파일',
    'drive.DriveUploadModal.abort-msg': '정말로 업로드를 취소하시겠습니까?',
    'drive.YoutubeDownloadModal.title': 'YouTube 다운로드',
    'drive.YoutubeDownloadModal.msg.empty-url': 'URL을 입력해주세요.',
    'drive.YoutubeMetadataForm.resolution': '해상도',
    'drive.YoutubeMetadataForm.subtitles': '자막 목록',

    'FriendListPage.title': '친구 목록',
    'FriendDetailPage.title': '친구 상세',
    'FriendDetailPage.delete-confirm': '정말로 {{0}}를 삭제하시겠습니까?',
    'FriendCreatePage.title': '친구 등록',
    'FriendUpdatePage.title': '친구 정보 수정',
    'FriendSearchPage.title': '친구 검색',
    'FriendForm.name': '이름',
    'FriendForm.birthday': '생일',
    'FriendForm.tags': '태그',
    'FriendForm.description': '메모',
    'FriendForm.meets': '만남',
    'FriendTagListPage.title': '태그 목록',
    'FriendTagDetailPage.title': '태그 상세 - {{0}}',
    'friend.invite-friend': '친구 초대',
    'friend.friend-list': '친구 목록',
    'FriendTagPreviewList.count': '{{cnt}} 개',

    'Dutch.should': '내야하는 돈',
    'Dutch.actual': '실제로 낸돈',
    'Dutch.amount': '금액',
    'Dutch.tripCurrency': '여행 통화',
    'Dutch.settleCurrency': '정산 통화',
    'Dutch.members': '멤버',
    'Dutch.currency-rate': '환율',
    'Dutch.settle-currency-rate': '정산 환율',
    'Dutch.settle': '정산',
    'Dutch.cash-status': '현금 현황',
    'Dutch.initial-balance': '준비 금액',
    'Dutch.spended-balance': '사용 금액',
    'Dutch.remaining-balance': '남은 금액',
    'DutchPayment.card': '카드',
    'DutchPayment.cash': '현금',
    'DutchHomePage.status': '현황',
    'DutchNavigation.home': '홈',
    'DutchNavigation.records': '내역',
    'DutchNavigation.balance': '마이',
    'DutchNavigation.settle': '정산',
    'DutchRecordListPage.title': '내역',
    'DutchRecordDetailPage.title': '내역 상세',
    'DutchRecordCreatePage.title': '내역 추가',
    'DutchRecordUpdatePage.title': '내역 수정',
    'DutchRecord.content': '내역',
    'DutchRecord.location': '장소',
    'DutchRecord.currency': '통화',
    'DutchRecord.payment': '지불방법',
    'DutchRecord.amount': '총액',
    'DutchRecord.date': '시간',
    'DutchRecord.members': '각자 몫',
    'DutchRecordMember.name': '이름',
    'DutchRecordMember.actual': '실제로 낸돈',
    'DutchRecordMember.should': '내야하는 돈',
    'DutchSettlePage.leader': '총무',
    'DutchSettleResultView.message.send': '{{name}}(이)가 {{amount}} 내야함',
    'DutchSettleResultView.message.receive': '{{name}}(이)가 {{amount}} 받아야함',
    'DutchMemberSelectPage.message.choose': '자신을 선택해주세요',
    'DutchSpendPage.select-member': '다른 유저 선택',
    'DutchRecordForm.feedback.invalid-sum': '내야하는 돈의 합과 실제로 낸돈의 합이 같지 않습니다',
    'DutchBalanceUpdatePage.title': '준비 금액 수정',

    'EncodeListPage.title': '목록',
    'EncodeDetailPage.title': '상세',
    'EncodeCreatePage.title': '추가',
    'EncodeForm.input': '원본 파일 경로',
    'EncodeForm.output': '결과 파일 경로',
    'EncodeForm.options': '인코딩 옵션',
    'EncodeForm.ffprobe': '메타데이터',
    'EncodePreviewItem.state.waiting': '대기',
    'EncodePreviewItem.state.running': '진행 중',
    'EncodePreviewItem.state.done': '완료',
    'EncodePreviewItem.state.failed': '실패',
    'EncodePreviewItem.registered': '{{time}} 등록',
    'EncodePreviewItem.elapsed': '소요 {{time}}',
    'EncodePreviewItem.finished': '{{time}} 완료',
    'EncodeRunningSection.title': '지금 인코딩 중',
    'EncodeProgress.calculating': '계산 중…',
    'EncodeProgress.remaining': '남은 시간 {{time}}',
    'EncodeProgress.elapsed': '경과 {{time}}',
    'EncodeProgress.processed': '{{current}} / {{total}}',
    'EncodeProgress.eta': '{{time}} 완료 예정',
    'EncodeDetail.id': 'ID',
    'EncodeDetail.callback': '콜백',
    'EncodeDetail.regDt': '등록',
    'EncodeDetail.startDt': '시작',
    'EncodeDetail.endDt': '종료',
    'EncodeDetail.elapsed': '소요 시간',

    'ArchiveListPage.title': '목록',
    'ArchiveDetailPage.title': '상세',
    'ArchiveCreatePage.title': '추가',
    'ArchiveCreatePage.files-label': '파일',
    'ArchiveCreatePage.drop-hint': '여기에 폴더를 드래그 앤 드롭하거나 클릭해서 폴더를 선택하세요',
    'ArchiveCreatePage.file-summary': '{{value}}개 파일 · {{size}}',
    'ArchiveCreatePage.clear': '비우기',
    'ArchiveCreatePage.no-index': '루트에 index.html이 없습니다. 뷰어에서 내용이 보이지 않을 수 있습니다.',
    'ArchiveCreatePage.uploading': '업로드 중...',
    'ArchiveCreatePage.upload-error': '파일 업로드에 실패했습니다.',
    'Archive.title': '이름',

    'PageSelectModal.title': '페이지 이동',
    'PageSelectModal.close': '취소',
    'PageSelectModal.move': '이동',
    'PageSelectModal.msg.invalid-page': '올바른 값을 입력해주세요',

    'menu.profile': '프로필 보기',

    'ChatPage.title': '채팅',
    'ChatPage.new-chat': '새 채팅',
    'ChatPage.empty': '무엇을 도와드릴까요?',
    'ChatPage.placeholder': '메시지를 입력하세요',
    'ChatPage.send': '전송',
    'ChatPage.stop': '중지',
    'ChatPage.thinking': '생각 중...',
    'ChatPage.thought': '생각 과정',
    'ChatPage.llm-online': 'LLM 켜짐',
    'ChatPage.llm-offline': 'LLM 꺼짐',
    'ChatPage.tokens-context': '컨텍스트',
    'ChatPage.llm-offline-hint': 'LLM 서버가 꺼져 있습니다. 켜지면 자동으로 사용할 수 있습니다',
    'ChatPage.llm-unavailable': 'LLM 서버에 연결할 수 없습니다. 서버가 꺼져 있을 수 있습니다.',
    'ChatPage.attach-image': '이미지 첨부',
    'ChatPage.remove-image': '이미지 제거',
    'ChatPage.model-vision': '이미지',
    'ChatPage.model-audio': '음성',
    'ChatPage.attach-audio': '오디오 파일 첨부',
    'ChatPage.remove-audio': '오디오 제거',
    'ChatPage.mic-start': '마이크로 녹음',
    'ChatPage.mic-stop': '녹음 끝내고 첨부',
    'ChatPage.mic-denied': '마이크를 사용할 수 없습니다. 브라우저의 마이크 권한을 확인해 주세요.',
    'ChatPage.audio-too-long': '오디오가 너무 깁니다. 4분 이내로 줄여 주세요.',
    'ChatPage.audio-failed': '오디오를 읽을 수 없습니다. 다른 형식으로 시도해 주세요.',
    'ChatPage.completed': '{{time}} 완료',
    'ChatPage.elapsed': '{{duration}} 걸림',
    'ChatPage.elapsed-seconds': '{{s}}초',
    'ChatPage.elapsed-minutes': '{{m}}분 {{s}}초',
    'HyunGPT.open-sidebar': '사이드바 열기',
    'HyunGPT.close-sidebar': '사이드바 닫기',
    'HyunGPT.search-placeholder': '대화 검색',
    'HyunGPT.clear': '지우기',
    'HyunGPT.loading': '불러오는 중…',
    'HyunGPT.no-sessions': '아직 대화가 없습니다',
    'HyunGPT.searching': '검색 중…',
    'HyunGPT.no-results': '검색 결과가 없습니다',
    'HyunGPT.result-count': '검색 결과 {{count}}개',
    'HyunGPT.group-today': '오늘',
    'HyunGPT.group-yesterday': '어제',
    'HyunGPT.group-week': '지난 7일',
    'HyunGPT.group-month': '지난 30일',
    'HyunGPT.group-older': '이전',
    'HyunGPT.rename': '이름 변경',
    'HyunGPT.delete-confirm': '이 대화를 삭제할까요? 되돌릴 수 없습니다.',
    'HyunGPT.llm-waking': 'LLM 켜는 중',
    'HyunGPT.model-search': '웹 검색',
    'HyunGPT.tokens-used': '사용',
    'HyunGPT.tokens-left': '남음',
    'HyunGPT.tokens-last': '마지막 응답',
    'HyunGPT.tokens-in-out': '입력 {{prompt}} · 생성 {{completion}}',
    'HyunGPT.copy': '복사',
    'HyunGPT.copied': '복사됨',
    'HyunGPT.jump-to-bottom': '맨 아래로',
    'HyunGPT.suggestion-1': '오늘 서울 날씨 알려줘',
    'HyunGPT.suggestion-2': '이메일을 정중하게 다듬어줘',
    'HyunGPT.suggestion-3': '파이썬으로 파일 이름 일괄 변경하는 코드',
    'HyunGPT.suggestion-4': '주말 근교 여행지 추천해줘',
    'hs.back': '뒤로',
    'hs.open-sidebar': '사이드바 열기',
    'hs.close-sidebar': '사이드바 닫기',
    'hs.clear': '지우기',
    'hs.chip-create': '"{{name}}" 추가',
    'hs.switch-service': '서비스 전환',
    'hs.services': '서비스',
    'hs.account': '계정',
    'hs.account-sub': 'Hyunsub 계정',
    'hs.profile': '프로필 관리',
    'hs.theme': '테마 설정',
    'hs.theme-light': '라이트',
    'hs.theme-dark': '다크',
    'hs.theme-system': '기기 설정',
    'hs.theme-desc': '고르면 바로 저장되어 모든 서비스에 적용됩니다.',
    'hs.language': '언어 설정',
    'hs.language-desc': '고르면 바로 저장되어 모든 서비스에 적용됩니다.',
    'hs.menu-title': '계정과 서비스',
    'hs.today': '오늘',
    'hs.close': '닫기',
    'hs.format-month': 'yyyy년 M월',
    'hs.n-selected': '{{cnt}}개 선택',
    'hs.cancel-select': '선택 끝내기',
    'HyunPhoto.nav-photos': '사진',
    'HyunPhoto.nav-albums': '앨범',
    'HyunPhoto.nav-downloads': '다운로드',
    'HyunPhoto.upload': '사진 올리기',
    'HyunPhoto.upload-subtitle': '사진·동영상을 올리면 날짜별로 정리돼요',
    'HyunPhoto.upload-to-album': '앨범에 올리기',
    'HyunPhoto.n-photos': '{{cnt}}장',
    'HyunPhoto.select': '선택',
    'HyunPhoto.filter': '거르기',
    'HyunPhoto.filter-name': '파일 이름',
    'HyunPhoto.filter-name-placeholder': '이름에 들어간 글자',
    'HyunPhoto.filter-period': '기간',
    'HyunPhoto.filter-start': '시작',
    'HyunPhoto.filter-end': '끝',
    'HyunPhoto.filter-tag': '태그',
    'HyunPhoto.filter-tag-placeholder': '태그 찾기',
    'HyunPhoto.filter-orphan': '앨범에 없는 사진만',
    'HyunPhoto.filter-reset': '조건 지우기',
    'HyunPhoto.filter-apply': '적용',
    'HyunPhoto.no-match': '조건에 맞는 사진이 없어요',
    'HyunPhoto.empty': '아직 사진이 없어요',
    'HyunPhoto.empty-desc': '사진을 올리면 찍은 날짜순으로 여기에 모여요.',
    'HyunPhoto.add-to-album': '앨범에 담기',
    'HyunPhoto.download': '다운로드',
    'HyunPhoto.delete': '삭제',
    'HyunPhoto.delete-confirm': '사진 {{cnt}}장을 삭제할까요? 담긴 앨범에서도 빠져요.',
    'HyunPhoto.shift-date': '날짜 옮기기',
    'HyunPhoto.shift-date-title': '고른 사진의 날짜를 같은 만큼 옮겨요',
    'HyunPhoto.shift-date-hint': '시간대가 틀린 사진 묶음을 고칠 때 써요. 음수는 이전으로.',
    'HyunPhoto.shift-later': '{{amount}}{{unit}} 뒤로 옮겨요',
    'HyunPhoto.shift-earlier': '{{amount}}{{unit}} 앞으로 옮겨요',
    'HyunPhoto.shift-apply': '옮기기',
    'HyunPhoto.unit-MINUTES': '분',
    'HyunPhoto.unit-HOURS': '시간',
    'HyunPhoto.unit-DAYS': '일',
    'HyunPhoto.unit-MONTHS': '개월',
    'HyunPhoto.unit-YEARS': '년',
    'HyunPhoto.new-album': '새 앨범',
    'HyunPhoto.new-album-placeholder': '새 앨범 이름',
    'HyunPhoto.create': '만들기',
    'HyunPhoto.album-not-found': '앨범을 찾을 수 없어요',
    'HyunPhoto.album-empty': '이 앨범은 비어 있어요',
    'HyunPhoto.album-empty-desc': '사진 목록에서 골라 담거나 바로 올려 보세요.',
    'HyunPhoto.rename-album': '이름 바꾸기',
    'HyunPhoto.share-album': '공유할 친구',
    'HyunPhoto.share-desc': '고른 친구도 이 앨범을 보고 사진을 담을 수 있어요. 앨범 주인만 바꿀 수 있어요.',
    'HyunPhoto.share-placeholder': '친구 찾기',
    'HyunPhoto.album-table': '표로 보기',
    'HyunPhoto.album-dates': '날짜 정보',
    'HyunPhoto.delete-album': '앨범 삭제',
    'HyunPhoto.album-delete-confirm': '"{{name}}" 앨범을 삭제할까요? 사진은 남아요.',
    'HyunPhoto.set-cover': '대표 사진으로',
    'HyunPhoto.remove-from-album': '앨범에서 빼기',
    'HyunPhoto.remove-from-album-confirm': '사진 {{cnt}}장을 이 앨범에서 뺄까요? 사진은 남아요.',
    'HyunPhoto.member-all': '전체',
    'HyunPhoto.save': '저장',
    'HyunPhoto.upload-choose': '사진·동영상 고르기',
    'HyunPhoto.upload-hint': '눌러서 고르거나 파일·폴더를 끌어다 놓으세요',
    'HyunPhoto.upload-files': '파일',
    'HyunPhoto.upload-size': '크기',
    'HyunPhoto.upload-remaining': '남은 시간',
    'HyunPhoto.upload-done': '완료',
    'HyunPhoto.upload-status-ready': '올릴 준비가 됐어요',
    'HyunPhoto.upload-status-uploading': '올리는 중 {{done}}/{{total}}',
    'HyunPhoto.upload-status-success': '{{total}}개 모두 올렸어요',
    'HyunPhoto.upload-status-error': '{{failed}}개는 올리지 못했어요',
    'HyunPhoto.upload-status-aborted': '중단했어요',
    'HyunPhoto.upload-clear': '비우기',
    'HyunPhoto.upload-start': '{{cnt}}개 올리기',
    'HyunPhoto.upload-abort': '중단',
    'HyunPhoto.upload-more': '더 올리기',
    'HyunPhoto.upload-view': '보러 가기',
    'HyunPhoto.downloads-subtitle': '골라서 묶은 사진 zip',
    'HyunPhoto.downloads-empty': '묶어 둔 사진이 없어요',
    'HyunPhoto.downloads-empty-desc': '사진을 골라 다운로드를 누르면 zip으로 묶여 여기에 생겨요.',
    'HyunPhoto.download-content': '{{content}} 외 {{total}}장',
    'HyunPhoto.download-ready': '받을 수 있어요',
    'HyunPhoto.download-progress': '묶는 중 {{progress}}/{{total}}',
    'HyunPhoto.photo-info': '사진 정보',
    'HyunPhoto.photo-not-found': '사진을 찾을 수 없어요',
    'HyunPhoto.view-original': '원본 보기',
    'HyunPhoto.info-date': '찍은 날짜',
    'HyunPhoto.info-date-type': '날짜 출처',
    'HyunPhoto.info-file-name': '파일 이름',
    'HyunPhoto.info-image-size': '해상도',
    'HyunPhoto.info-file-size': '파일 크기',
    'HyunPhoto.info-model': '카메라',
    'HyunPhoto.info-reg-dt': '올린 날짜',
    'HyunPhoto.info-tags': '태그',
    'HyunPhoto.edit-date': '날짜 고치기',
    'HyunPhoto.tags-placeholder': '태그 더하기',
    'HyunPhoto.go-to-detail': '자세히 보기',
    'HyunPhoto.vision': 'AI 분석 (베타)',
    'HyunPhoto.vision-caption': '설명',
    'HyunPhoto.vision-tagging': '분류',
    'HyunPhoto.vision-objects': '사물 찾기',
    'HyunPhoto.vision-model': '모델 고르기',
    'hs.previous': '이전',
    'hs.next': '다음',
    'HyunComic.nav-home': '홈',
    'HyunComic.nav-history': '읽은 기록',
    'HyunComic.nav-comics': '만화',
    'HyunComic.continue': '이어 읽기',
    'HyunComic.all-comics': '모든 만화',
    'HyunComic.see-all': '모두 보기',
    'HyunComic.n-episodes': '{{cnt}}화',
    'HyunComic.n-pages': '{{cnt}}쪽',
    'HyunComic.page-of': '{{page}} / {{total}}쪽',
    'HyunComic.episode-page': '{{episode}} · {{page}}/{{total}}쪽',
    'HyunComic.episode-done': '{{episode}} 다 읽음',
    'HyunComic.page-in': '{{episode}} {{page}}쪽부터',
    'HyunComic.next-up': '다음 화',
    'HyunComic.done': '다 읽음',
    'HyunComic.last-read': '읽던 곳',
    'HyunComic.read-count': '{{cnt}}화 읽음',
    'HyunComic.resume': '이어 읽기',
    'HyunComic.start': '첫 화부터 읽기',
    'HyunComic.episodes': '회차',
    'HyunComic.sort-first': '처음부터',
    'HyunComic.sort-latest': '최신부터',
    'HyunComic.empty-home': '아직 만화가 없어요',
    'HyunComic.empty-history': '아직 읽은 만화가 없어요',
    'HyunComic.not-found': '만화를 찾을 수 없어요',
    'HyunComic.episode-not-found': '이 화를 찾을 수 없어요',
    'HyunComic.reading-mode': '읽는 방식',
    'HyunComic.mode-ltr': '오른쪽으로 넘기기',
    'HyunComic.mode-rtl': '왼쪽으로 넘기기 (일본 만화)',
    'HyunComic.mode-scroll': '세로로 이어 보기',
    'HyunComic.prev-episode': '이전 화',
    'HyunComic.next-episode': '다음 화',
    'HyunComic.end-of': '{{episode}} 끝',
    'HyunComic.read-next': '다음 화 읽기',
    'HyunComic.end-latest': '마지막 화까지 다 읽었어요',
    'HyunComic.episode-list': '회차 목록',

    'HyunVideo.nav-home': '홈',
    'HyunVideo.nav-search': '검색',
    'HyunVideo.nav-history': '시청 기록',
    'HyunVideo.nav-categories': '카테고리',
    'HyunVideo.admin': '관리자 화면',
    'HyunVideo.continue': '이어보기',
    'HyunVideo.see-all': '모두 보기',
    'HyunVideo.n-titles': '{{cnt}}편',
    'HyunVideo.sort': '정렬',
    'HyunVideo.sort-random': '무작위',
    'HyunVideo.sort-new': '최근 추가순',
    'HyunVideo.sort-old': '오래된 순',
    'HyunVideo.sort-abc': '이름순',
    'HyunVideo.sort-zyx': '이름 역순',
    'HyunVideo.remaining': '{{time}} 남음',
    'HyunVideo.duration-hm': '{{h}}시간 {{m}}분',
    'HyunVideo.duration-m': '{{m}}분',
    'HyunVideo.watched': '다 봤어요',
    'HyunVideo.episode-n': '{{n}}화',
    'HyunVideo.episode-special': '스페셜',
    'HyunVideo.episodes': '회차',
    'HyunVideo.n-episodes': '{{cnt}}화',
    'HyunVideo.now-playing': '재생 중',
    'HyunVideo.play-next': '다음 화',
    'HyunVideo.more-in-group': '{{name}} 묶음의 작품',
    'HyunVideo.subtitles': '자막',
    'HyunVideo.subtitle-size': '자막 크기',
    'HyunVideo.subtitle-sync': '자막 싱크',
    'HyunVideo.subtitle-sync-hint': '밀리초(ms) 단위로 자막 시간을 옮겨요. 이번 재생에만 적용돼요.',
    'HyunVideo.no-subtitles': '이 영상에는 자막이 없어요',
    'HyunVideo.manage': '관리',
    'HyunVideo.video-manage': '영상 관리',
    'HyunVideo.entry-manage': '작품 관리',
    'HyunVideo.search-placeholder': '작품 이름으로 찾기',
    'HyunVideo.search-hint': '보고 싶은 작품을 찾아보세요',
    'HyunVideo.search-empty': '"{{query}}"에 맞는 작품이 없어요',
    'HyunVideo.empty-home': '아직 볼 수 있는 작품이 없어요',
    'HyunVideo.list-empty': '이 카테고리에 작품이 없어요',
    'HyunVideo.no-category': '카테고리를 찾을 수 없어요',
    'HyunVideo.not-found': '작품을 찾을 수 없어요',
    'HyunVideo.history-empty': '아직 본 영상이 없어요',
    'HyunVideo.history-empty-desc': '영상을 보면 여기서 이어 볼 수 있어요',
    'HyunVideo.select': '선택',
    'HyunVideo.history-delete': '기록 지우기',
    'HyunVideo.history-delete-confirm': '시청 기록 {{cnt}}개를 지울까요?',
    'HyunVideo.choose': '고르세요',
    'HyunVideo.none': '없음',
    'HyunVideo.required': '꼭 입력해야 해요',
    'HyunVideo.output-mp4': '.mp4로 끝나는 경로여야 해요',
    'HyunVideo.create-entry': '작품 만들기',
    'HyunVideo.create-entry-desc': '빈 작품을 만들고 작품 관리 화면으로 가요. 폴더도 함께 만들어요.',
    'HyunVideo.create': '만들기',
    'HyunVideo.register-video': '영상 등록',
    'HyunVideo.register-video-desc': '원본 파일을 옮겨 새 작품(영상)으로 등록해요.',
    'HyunVideo.register': '등록',
    'HyunVideo.register-to-entry': '이 작품에 영상 등록',
    'HyunVideo.register-to-entry-desc': '원본 파일을 옮겨 이 작품의 영상으로 더해요.',
    'HyunVideo.field-name': '이름',
    'HyunVideo.field-category': '카테고리',
    'HyunVideo.field-group': '묶음',
    'HyunVideo.field-new-group': '새 묶음 이름',
    'HyunVideo.field-thumbnail-url': '표지 URL',
    'HyunVideo.field-source-path': '원본 경로',
    'HyunVideo.field-output-path': '저장할 경로(.mp4)',
    'HyunVideo.field-season': '시즌',
    'HyunVideo.field-old-path': '지금 경로',
    'HyunVideo.field-new-path': '새 경로',
    'HyunVideo.field-from': '바꿀 것(정규식)',
    'HyunVideo.field-to': '바꿀 내용',
    'HyunVideo.field-options': 'ffmpeg 옵션',
    'HyunVideo.field-lang': '언어 코드',
    'HyunVideo.field-override': '같은 언어 자막이 있으면 덮어쓰기',
    'HyunVideo.field-subtitle-file': '자막 파일',
    'HyunVideo.field-subtitle-path': '서버의 자막 파일',
    'HyunVideo.scan': '폴더 다시 훑기',
    'HyunVideo.scan-desc': '작품 폴더에서 새 영상·자막을 찾아 등록하고, 바뀐 자막을 맞춰요.',
    'HyunVideo.scan-run': '훑기',
    'HyunVideo.rename-bulk': '파일 이름 일괄 변경',
    'HyunVideo.rename-bulk-desc': '정규식으로 이 작품의 영상·썸네일·자막 파일 이름을 한꺼번에 바꿔요.',
    'HyunVideo.rename-run': '바꾸기',
    'HyunVideo.move': '폴더 옮기기',
    'HyunVideo.move-desc': '작품 폴더를 새 경로로 옮겨요. 먼저 미리 보기로 확인하세요.',
    'HyunVideo.dry-run': '미리 보기만(실제로 옮기지 않음)',
    'HyunVideo.move-run': '옮기기',
    'HyunVideo.run': '실행',
    'HyunVideo.save': '저장',
    'HyunVideo.upload': '올리기',
    'HyunVideo.metadata': '메타데이터 다시 읽기',
    'HyunVideo.metadata-desc': 'ffprobe로 길이·해상도·크기·비트레이트를 다시 읽어요.',
    'HyunVideo.thumbnail': '썸네일 다시 만들기',
    'HyunVideo.thumbnail-desc': '영상에서 썸네일을 다시 만들어요.',
    'HyunVideo.subtitle-upload': '자막 더하기',
    'HyunVideo.subtitle-upload-desc': '자막 파일을 올리거나 서버에 있는 자막 파일을 옮겨 붙여요.',
    'HyunVideo.subtitle-mode-upload': '파일 올리기',
    'HyunVideo.subtitle-mode-move': '서버 파일 옮기기',
    'HyunVideo.subtitle-sync-save': '자막 싱크 저장',
    'HyunVideo.subtitle-sync-save-desc': '자막 파일 자체의 시간을 옮겨 저장해요(모든 사람에게 적용).',
    'HyunVideo.encode': '인코딩',
    'HyunVideo.encode-desc': '파일 서버에서 다시 인코딩해요. 끝나면 메타데이터를 다시 읽어요.',
    'HyunVideo.encode-run': '인코딩 시작',
    'HyunVideo.rename': '파일 이름 바꾸기',
    'HyunVideo.rename-desc': '이 영상 파일 이름에서 바꿀 부분을 바꿔요.',
    'hs.format-year': '{{year}}년',
    'hs.prev-day': '전날',
    'hs.next-day': '다음 날',
    'hs.pick-date': '날짜 고르기',
    'hs.prev-month': '이전 달',
    'hs.next-month': '다음 달',
    'hs.file-choose': '파일 고르기',
    'hs.file-drop-hint': '눌러서 고르거나 여기로 끌어다 놓으세요',
    'hs.file-change': '눌러서 바꾸기',

    'HyunTimeline.nav-day': '하루 동선',
    'HyunTimeline.nav-import': '기록 가져오기',
    'HyunTimeline.format-day': 'M월 d일 cccc',
    'HyunTimeline.format-full': 'yyyy년 M월 d일 (ccc)',
    'HyunTimeline.year': '{{year}}년',
    'HyunTimeline.day-subtitle': '{{year}}년 · {{distance}} 이동',
    'HyunTimeline.all-day': '하루 전체',
    'HyunTimeline.reset-range': '전체 보기',
    'HyunTimeline.range-start': '시작 시각',
    'HyunTimeline.range-end': '끝 시각',
    'HyunTimeline.empty-title': '이 날의 기록이 없어요',
    'HyunTimeline.empty-description': '앱이 보낸 위치나 가져온 기록이 있으면 여기에 동선이 그려져요.',
    'HyunTimeline.flow': '하루 흐름',
    'HyunTimeline.show-all': '전체 보기',
    'HyunTimeline.stat-distance': '이동 거리',
    'HyunTimeline.stat-time': '기록 시간',
    'HyunTimeline.stat-count': '기록 수',
    'HyunTimeline.speed': '속도',
    'HyunTimeline.altitude': '고도',
    'HyunTimeline.accuracy': '정확도',
    'HyunTimeline.open-in-maps': '지도 앱에서 열기',
    'HyunTimeline.stay': '{{duration}} 머묾',
    'HyunTimeline.move': '{{distance}} 이동',
    'HyunTimeline.avg-speed': '평균 {{speed}}km/h',
    'HyunTimeline.gap': '기록 없음 · {{duration}}',
    'HyunTimeline.gap-distance': '직선 {{distance}}',
    'HyunTimeline.duration-hm': '{{h}}시간 {{m}}분',
    'HyunTimeline.duration-m': '{{m}}분',
    'HyunTimeline.import-subtitle': 'Google 위치 기록에서 하루치를 가져와요',
    'HyunTimeline.import-step-1': 'Google 지도 앱에서 타임라인(위치 기록)을 JSON으로 내보내요.',
    'HyunTimeline.import-step-2': '파일과 가져올 날짜를 고르면, 이미 있는 기록과 비교해 새 좌표만 골라요.',
    'HyunTimeline.import-step-3': '지도에서 확인한 뒤 가져오기를 누르면 동선에 더해져요.',
    'HyunTimeline.import-file': '파일',
    'HyunTimeline.import-choose-file': 'JSON 파일 고르기',
    'HyunTimeline.import-date': '가져올 날짜',
    'HyunTimeline.import-compare': '새 기록 찾기',
    'HyunTimeline.import-new': '새 기록 {{count}}개',
    'HyunTimeline.import-parsed': '파일에서 이 날짜 좌표 {{count}}개를 읽었어요',
    'HyunTimeline.import-nothing': '새로 가져올 기록이 없어요',
    'HyunTimeline.import-nothing-description': '이 날짜의 좌표는 이미 모두 저장되어 있어요.',
    'HyunTimeline.import-list': '좌표 {{count}}개 모두 보기',
    'HyunTimeline.import-cancel': '다시 고르기',
    'HyunTimeline.import-apply': '{{count}}개 가져오기',
    'HyunTimeline.import-done': '가져왔어요',
    'HyunTimeline.import-done-description': '이제 그 날의 동선에서 볼 수 있어요.',
    'HyunTimeline.view-day': '그 날 동선 보기',
    'HyunTimeline.import-another': '다른 파일 가져오기',
    'HyunDiary.nav-list': '일기',
    'HyunDiary.nav-calendar': '캘린더',
    'HyunDiary.nav-tags': '태그',
    'HyunDiary.nav-stats': '통계',
    'HyunDiary.write': '일기 쓰기',
    'HyunDiary.write-today': '오늘 일기 쓰기',
    'HyunDiary.write-this-day': '이 날 일기 쓰기',
    'HyunDiary.edit': '일기 수정',
    'HyunDiary.save': '저장',
    'HyunDiary.total-count': '총 {{cnt}}편',
    'HyunDiary.result-count': '검색 결과 {{cnt}}편',
    'HyunDiary.month-count': '이번 달 {{cnt}}편',
    'HyunDiary.entry-count': '{{cnt}}편',
    'HyunDiary.tag-count': '{{cnt}}개',
    'HyunDiary.letters': '{{cnt}}자',
    'HyunDiary.search-placeholder': '일기 검색',
    'HyunDiary.tag-search-placeholder': '태그 검색',
    'HyunDiary.no-results': '찾는 일기가 없어요',
    'HyunDiary.empty': '아직 쓴 일기가 없어요',
    'HyunDiary.empty-desc': '오늘 있었던 일을 짧게라도 남겨 보세요.',
    'HyunDiary.no-diary': '이 날의 일기가 없어요',
    'HyunDiary.no-tags': '아직 태그가 없어요',
    'HyunDiary.no-tags-desc': '일기를 쓸 때 태그를 달면 여기에 모입니다.',
    'HyunDiary.no-photos': '이 날 찍은 사진이 없어요',
    'HyunDiary.today-question': '오늘 하루는 어땠나요?',
    'HyunDiary.view-calendar': '캘린더로 보기',
    'HyunDiary.view-all': '모두 보기',
    'HyunDiary.read-more': '전체 읽기',
    'HyunDiary.photos': '사진 {{cnt}}장',
    'HyunDiary.timeline': '그날의 이동 기록',
    'HyunDiary.open-timeline': 'HyunTimeline에서 보기',
    'HyunDiary.delete-confirm': '이 일기를 삭제할까요? 되돌릴 수 없습니다.',
    'HyunDiary.tag-delete-confirm': '#{{name}} 태그를 삭제할까요? 일기에서도 빠집니다.',
    'HyunDiary.rename': '이름 변경',
    'HyunDiary.summary-placeholder': '오늘을 한 줄로 요약하면?',
    'HyunDiary.friends-placeholder': '함께한 사람',
    'HyunDiary.tags-placeholder': '태그',
    'HyunDiary.content-placeholder': '오늘 있었던 일을 적어 보세요',
    'HyunDiary.draft-saved': '임시 저장됨',
    'HyunDiary.overwrite-notice': '이 날짜에는 이미 일기가 있어요. 저장하면 덮어씁니다.',
    'HyunDiary.edit-existing': '기존 일기 수정',
    'HyunDiary.stats-total': '쓴 일기',
    'HyunDiary.stats-unit-entry': '편',
    'HyunDiary.stats-period': '기록한 기간',
    'HyunDiary.stats-coverage': '기록률',
    'HyunDiary.stats-coverage-hint': '{{days}}일 중 일기를 쓴 날',
    'HyunDiary.stats-average': '평균 길이',
    'HyunDiary.stats-unit-letter': '자',
    'HyunDiary.stats-total-letters': '모두 {{cnt}}자',
    'HyunDiary.stats-distribution': '글자 수 분포',
    'HyunDiary.stats-longest': '가장 길게 쓴 날',
    'HyunDiary.stats-bucket': '약 {{range}}자 · {{cnt}}편',
    'HyunDiary.format-full': 'yyyy년 M월 d일 cccc',
    'HyunDiary.format-short': 'yyyy. M. d. (ccc)',
    'HyunDiary.format-date': 'yyyy. M. d.',
    'ChatPage.searching': '검색 중',
    'ChatPage.searched': '검색함',
    'ChatPage.sources': '출처',
  },
};

export default ko;
